/** Base modular pixel unit — all part art dimensions are multiples of this. */
export const GRID_UNIT = 48;

export const STORAGE_KEY = "rocket-builder-progress-v2";
